import { CustomChip } from 'src/shared/components/organisms/customChip';
import { getSendingOrderStatusMeta } from 'src/modules/sending/models/sendingOrderStatus';

interface SendingOrderStatusBadgeProps {
  status: number | undefined | null;
  size?: 'small' | 'medium';
}

// Använder delade CustomChip så statusbrickan följer samma design som t.ex. medlemsregistrets statuschips.
export const SendingOrderStatusBadge = ({ status, size = 'small' }: SendingOrderStatusBadgeProps) => {
  const meta = getSendingOrderStatusMeta(status);

  return <CustomChip label={meta.label} color={meta.color} size={size} smallRadius />;
};
